// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XzQbX","icon":"styles_icon__3bbm-"};